import { render, staticRenderFns } from "./feedListView.vue?vue&type=template&id=3b1be3e2&"
import script from "./feedListView.vue?vue&type=script&lang=js&"
export * from "./feedListView.vue?vue&type=script&lang=js&"
import style0 from "./feedListView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports